const en: Record<string, string> = {
  'features.guitarTuner.startMic': 'Start',
  'features.guitarTuner.stopMic': 'Stop',
  'features.guitarTuner.requesting': 'Requesting microphone…',
  'features.guitarTuner.micDenied': 'Microphone access denied. Please allow microphone access and try again.',
  'features.guitarTuner.flat': 'Too low — tighten',
  'features.guitarTuner.sharp': 'Too high — loosen',
  'features.guitarTuner.inTune': '✓ In tune',
  'features.guitarTuner.string': 'String',
};

export default en;
